import { render } from "./LinkIconOnly.vue?vue&type=template&id=80a393c6"
import script from "./LinkIconOnly.vue?vue&type=script&lang=js"
export * from "./LinkIconOnly.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__